<div style="padding: 10px;">
  <h2 mat-dialog-title>Resposta da Requisição</h2>

  <mat-dialog-content class="json-container">
    <pre>{{ texto }}</pre>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button-padrao width="100px" label="Fechar" (buttonClick)="dialog.close()"></app-button-padrao>
  </mat-dialog-actions>
</div>

